module.exports = __webpack_public_path__ + "img/sample-selfie1.8d4eaf65.png";